import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { Clock, ShoppingBag, Search, MessageSquare } from "lucide-react";
const LoesungEinzelhandelSection = () => <IndustrySolutionI18n translationPrefix="industryEinzelhandel" icons={[Clock, ShoppingBag, Search, MessageSquare]} />;
export default LoesungEinzelhandelSection;
